module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-22.3f343633.jpg";